import {Injectable} from '@angular/core';
import {ListDataState} from '../modules/akita-mimic/models/store-states/list-data-state.model';
import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';
import {PaginatedListData} from '../models/paginated-list-data.model';


@Injectable({ providedIn: 'root' })
export class ListDataStore extends EntityStoreService<ListDataState, PaginatedListData> {
    public constructor() {
        super('list-data', {
            active: [],
            loading: false,
            entities: {},
            ids: [],
            error: null,
            marked: [],
            deleted: [],
            settings: {
                idKey: 'id'
            },
        });
    }
}
